import { render, staticRenderFns } from "./CollectiveVisits.vue?vue&type=template&id=3ea1c872&scoped=true"
import script from "./CollectiveVisits.vue?vue&type=script&lang=js"
export * from "./CollectiveVisits.vue?vue&type=script&lang=js"
import style0 from "./CollectiveVisits.vue?vue&type=style&index=0&id=3ea1c872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea1c872",
  null
  
)

export default component.exports